@if (initialized) {
    <div class="grid mt-2">
        <div class="col-12">
            <div class="flex justify-content-between py-2 px-4 surface-0 align-items-center shadow-1 border-round">
                <span style="font-size:16px; font-weight: 600;">Spring Batch Übersicht</span>
                <mvs-range-selector-overlay fieldName="e.start_time" (onChangeFilterCriteria)="handleFilterCriteria($event)"></mvs-range-selector-overlay>
            </div>
        </div>

        @if (stats?.length) {
            <div class="col-12">
                <div class="card p-3 shadow-1 border-round surface-0">
                    <div class="flex justify-content-between align-items-center">
                        <div
                                *ngFor="let stat of stats; let first = first"
                                class="flex flex-column flex-1 justify-content-center surface-border pl-4"
                                [ngClass]="{'border-left-1': !first, 'cursor-pointer' : stat.navigate}" (click)="handleStatClick(stat)">
                            <div class="flex align-items-center">
                                <i [class]="stat.icon" [ngStyle]="{'color': stat.color}"></i>
                                <small class="text-500 font-medium ml-2">{{ stat.label }}</small>
                            </div>
                            <div
                                    class="text-2xl font-bold mt-1">
                                {{ stat.value }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="col-12">
            @if (jobOverviewReportWidget) {
                <mvs-widget class="shadow-1 border-round block"
                        [widgetData]="jobOverviewReportWidget"
                        (onObjectSelect)="handleObjectSelect($event)"
                ></mvs-widget>
            }
        </div>
    </div>
}